import { defaultFilter as TableDefaultFilter } from '@components/Table/table.utils';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { toolCoverageDefaultFilter } from '../../../../../views/Policies/ToolCoverageAndGap/utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/assets/tool-coverage-and-gap/')({
  validateSearch: zodValidator(withDefaults(schema.TOOL_COVERAGE_AND_GAP, TableDefaultFilter, toolCoverageDefaultFilter)),
  search: {
    middlewares: [stripSearchParams(TableDefaultFilter)],
  },
});
